import {
  IAdsConfiguration,
  IAppnexusOutstreamPlayerConfiguration,
} from "@almamedia/amr-adtech-stack/lib/services/ads/adsservice";
// import { IXandrVideoAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads";
import placements from "./placements";
import targeting from "./ad-targeting";
import { ICustomVariables } from "../data-layer/data-layer";
import { SiteNativeTemplate } from "../native/native";
// import { outstream } from "./custom-needs/outstream";
import {
  changeParadeId,
  programmaticWallpaper,
} from "./custom-needs/custom-needs";

declare global {
  interface Window {
    pageChangedFirstTime?: boolean;
  }
}

const ads: IAdsConfiguration<ICustomVariables, SiteNativeTemplate> = {
  enabled: true,
  placements,
  targeting,
  defaults: {
    astJs: {
      disablePsa: true,
      allowSmallerSizes: false,
      allowedFormats: ["banner"],
      nobidIfUnsold: false,
    },
    memberId: 6931,
    autoInit: false,
    geoTimeout: 200,
    contextual: {
      relevancyLimits: {
        iabTier1: {
          min: 0,
          max: 100,
        },
        iabTier2: {
          min: 10,
          max: 100,
        },
        semantics: {
          min: 10,
          max: 100,
        },
      },
    },
  },
  customNeeds: {
    preAdRequest: (): true | { reason: string } => {
      const digitalDataPrimaryCategory =
        window?.digitalData?.page?.category?.primaryCategory ?? "noads";

      if (
        digitalDataPrimaryCategory === "(none)" ||
        digitalDataPrimaryCategory === ""
      ) {
        return {
          reason: "Cancelled because of DDL primaryCategory === 'noads'",
        };
      }

      // MAINONTA-2419 Tilanvaraus pois
      // if (window.innerWidth > 979 && window.apntag && window.apntag.loaded) {
      //   paradeStyles("400px");
      // }

      if (window.pageChangedFirstTime) {
        if (window.programmaticWallpaper) {
          programmaticWallpaper(true);
          window.programmaticWallpaper = false;
        } else {
          changeParadeId(true);
        }
      } else {
        window.pageChangedFirstTime = true;
      }
      return true;
    },
  },
  user: {
    gender: 1,
  },
  roadblocks: [
    {
      primary: "almad-parade-1",
      secondaries: [
        "almad-wallpaper-1",
        "almad-skyscraper-1",
        "almad-skyscraper-2",
      ],
      sections: [
        "etusivu_desktop_wide",
        "uutiset_desktop_wide",
        "uutiset_desktop_wide_article",
        "uutiset_desktop_wide_article_sponsored",
        "tyoelama-talous_desktop_wide",
        "tyoelama-talous_desktop_wide_article",
        "tyoelama-talous_desktop_wide_article_sponsored",
        "urheilu_desktop_wide",
        "urheilu_desktop_wide_article",
        "urheilu_desktop_wide_article_sponsored",
        "viihde_desktop_wide",
        "viihde_desktop_wide_article",
        "viihde_desktop_wide_article_sponsored",
        "saa_desktop_wide",
        "iltv_desktop_wide",
        "iltv_desktop_wide_article",
        "iltv_desktop_wide_article_sponsored",
        "terveys_desktop_wide",
        "terveys_desktop_wide_article",
        "terveys_desktop_wide_article_sponsored",
        "tyylicom_desktop_wide",
        "tyylicom_desktop_wide_article",
        "tyylicom_desktop_wide_article_sponsored",
        "asuminen_desktop_wide",
        "asuminen_desktop_wide_article",
        "asuminen_desktop_wide_article_sponsored",
        "perhe_desktop_wide",
        "perhe_desktop_wide_article",
        "perhe_desktop_wide_article_sponsored",
        "pippuri_desktop_wide",
        "pippuri_desktop_wide_article",
        "pippuri_desktop_wide_article_sponsored",
        "matkailu_desktop_wide",
        "matkailu_desktop_wide_article",
        "matkailu_desktop_wide_article_sponsored",
        "autot_desktop_wide",
        "autot_desktop_wide_article",
        "autot_desktop_wide_article_sponsored",
        "digi_desktop_wide",
        "digi_desktop_wide_article",
        "digi_desktop_wide_article_sponsored",
      ],
    },
  ],
  outstream: {
    rendererOptions: {
      autoInitialSize: true,
      alignment: "left",
      playOnMouseover: false,
      audioOnMouseover: true,
      playVideoVisibleThreshold: 15,
      expandTime: 1000,
      waterfallTimeout: 5e3,
      waterfallSteps: 3,
      adText: "ILMOITUS",
      showMute: true,
      showVolume: false,
      showProgressBar: true,
      allowFullscreen: true,
      vpaidTimeout: 5000,
      terminateUnresponsiveVPAIDCreative: false,
      enableInlineVideoForIos: true,
      disableCollapse: {
        enabled: true,
      },
      aspectRatio: "auto",
      delayExpandUntilVPAIDInit: true,
      delayExpandUntilVPAIDImpression: false,
      disableTopBar: false,
      controlBarPosition: "over",
      nonViewableBehavior: "pause",
      skippable: {
        enabled: false,
      },
      playerSkin: {
        topBarColor: "#FFFFFF",
      },
    },
    preRequest: (
      config: IAppnexusOutstreamPlayerConfiguration
    ): IAppnexusOutstreamPlayerConfiguration => {
      return {
        ...config,
        allowFullscreen:
          !navigator.userAgent.match(/(iPod|iPhone|iPad)/) ||
          !navigator.userAgent.match(/AppleWebKit/),
        // Vertical video
        maxHeight: {
          enabled: true,
          height: window.innerWidth >= 980 ? 877 : 600,
        },
      };
    },
    // postResponse: (adObject: IXandrVideoAdObject): void => {
    //   outstream(adObject);
    // },
  },
};

export default ads;
